import React from "react";
import ReactDOM from "react-dom/client";
import { configureAuth } from "@d-m-organization/hub-shared-lib/auth";
import { useAuth } from "@d-m-organization/hub-shared-lib/auth/core";
import { setAuthHook } from "@d-m-organization/pricing-ui";
import "./i18n/index.js";
import "./index.css";
// HD-97 M4: qr-ui ships its own stylesheet — eager-import once so the
// dashboard spotlight and the lazy /qr/new sheet both pick up the same
// styles without an FOUC on lazy mount.
import "@d-m-organization/qr-ui/styles.css";
import { App } from "./App.js";

// ─── One-time pricing auth bridge ───────────────────────────────────────────
setAuthHook(useAuth);

// ─── One-time Amplify auth configuration ─────────────────────────────────────

configureAuth({
  userPoolId: import.meta.env.VITE_USER_POOL_ID,
  userPoolClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID,
  domain: import.meta.env.VITE_COGNITO_DOMAIN,
  redirectSignIn: [`${window.location.origin}/auth/callback`],
  redirectSignOut: [`${window.location.origin}/`],
  scopes: ["openid", "email", "profile", "https://api.gen-pro-hub.com/qr.read"],
});

// ─── Mount ───────────────────────────────────────────────────────────────────

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
